module.exports = __webpack_public_path__ + "img/icon-sepa@3x.c6b5a67b.png";